module.exports = __webpack_public_path__ + "static/media/16.1d4fe2ba.jpg";